export default class EnhancedCoreRegistry {
    constructor() {
        this.pluginDataRegistry = new Map();
    }

    pluginExists(pluginIdentifier, selectorIdentifier) {
        if (!selectorIdentifier) {
            return this.pluginDataRegistry.has(pluginIdentifier);
        }

        if (!this.pluginDataRegistry.has(pluginIdentifier)) {
            this.pluginDataRegistry.set(pluginIdentifier, new Map());
        }

        const pluginConfigurations = this.pluginDataRegistry.get(pluginIdentifier);
        const hasRegistrations = pluginConfigurations.has('registrations');
        return hasRegistrations ? pluginConfigurations.get('registrations').has(selectorIdentifier) : false;
    }

    addPlugin(pluginIdentifier, pluginClass, selectorIdentifier, configurationOptions) {
        if (!this.pluginExists(pluginIdentifier)) {
            this.pluginDataRegistry.set(pluginIdentifier, new Map());
        }

        const pluginConfigurations = this.pluginDataRegistry.get(pluginIdentifier);

        pluginConfigurations.set('class', pluginClass);
        pluginConfigurations.set('identifier', pluginIdentifier);

        if (!pluginConfigurations.has('registrations')) {
            pluginConfigurations.set('registrations', new Map());
        }

        if (!pluginConfigurations.has('instances')) {
            pluginConfigurations.set('instances', []);
        }

        const registrationDetails = pluginConfigurations.get('registrations');
        if (selectorIdentifier) {
            registrationDetails.set(selectorIdentifier, {selector: selectorIdentifier, options: configurationOptions});
        }

        return this;
    }

    getPlugin(pluginIdentifier) {
        return this.pluginDataRegistry.get(pluginIdentifier);
    }

    removePlugin(pluginIdentifier, selectorIdentifier) {
        if (!selectorIdentifier) {
            return this.pluginDataRegistry.delete(pluginIdentifier);
        }

        const pluginConfigurations = this.pluginDataRegistry.get(pluginIdentifier);
        if (!pluginConfigurations) {
            return false;
        }

        const registrationDetails = pluginConfigurations.get('registrations');
        if (!registrationDetails) {
            return false;
        }

        registrationDetails.delete(selectorIdentifier);

        return this;
    }

    clearPlugins() {
        this.pluginDataRegistry.clear();

        return this;
    }

    getPluginNamesAndData() {
        return Array.from(this.pluginDataRegistry).reduce((accumulator, values) => {
            const [key, value] = values;
            accumulator[key] = value;
            return accumulator;
        }, {});
    }
}
